import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import ByzMuiTypography from 'src/components/core-components/mui/inputs/ByzMuiTypography';
import ByzMcParameterDetailSelect from 'src/components/shared-components/ByzMcParameterDetailSelect';
import ByzMcParameterDetailRadio from 'src/components/shared-components/ByzMcParameterDetailRadio';
import { McParameterDetailResponseDto } from 'src/api/references/referenceServicesDtos';
import { useTranslate } from 'src/locales/use-locales';
import type { CapriniRiskAssessmentData } from '../models';

interface RiskFactorFieldProps {
  labelKey: string;
  fieldKey: keyof CapriniRiskAssessmentData;
  mcpId: number;
  value: McParameterDetailResponseDto | McParameterDetailResponseDto[] | null;
  onMCPChange: (field: keyof CapriniRiskAssessmentData, value: McParameterDetailResponseDto) => void;
  cachedData: McParameterDetailResponseDto[];
  cacheLoaded: boolean;
  extraAccess?: boolean;
  fieldType?: 'select' | 'radio';
}

export const RiskFactorField: React.FC<RiskFactorFieldProps> = ({
  labelKey,
  fieldKey,
  mcpId,
  value,
  onMCPChange,
  cachedData,
  cacheLoaded,
  extraAccess,
  fieldType = 'radio',
}) => {
  const { t } = useTranslate();

  return (
    <Grid 
      container 
      alignItems="center" 
      justifyContent="space-between"
      sx={{
        minHeight: fieldType === 'radio' ? '48px' : 'auto',
      }}
    >
      <Grid
        xs={12}
        sm={6}
        md={6}
        sx={{
          borderBottom: '1px solid #E0E0E0',
          display: 'flex',
          alignItems: 'center',
          paddingY: fieldType === 'radio' ? 1 : 1.5,
          paddingLeft: '30px',
        }}
      >
        <ByzMuiTypography
          fontWeight={500}
          fontSize="14px"
          sx={{
            width: '100%',
            textAlign: 'left',
          }}
        >
          {t(labelKey)}
        </ByzMuiTypography>
      </Grid>
      <Grid
        xs={12}
        sm={6}
        md={6}
        sx={{
          display: 'flex',
          alignItems: 'center',
          paddingY: fieldType === 'radio' ? 1 : 1.5,
          paddingX: 1,
        }}
      >
        {fieldType === 'select' ? (
          <ByzMcParameterDetailSelect
            title={t(labelKey)}
            mcpId={mcpId}
            multiple={false}
            handleChange={(val) => {
              if (val && !Array.isArray(val)) {
                onMCPChange(fieldKey, val);
              }
            }}
            value={value}
            sx={{ width: '100%' }}
            cachedData={cachedData}
            cacheLoaded={cacheLoaded}
            readOnly={!extraAccess}
          />
        ) : (
          <ByzMcParameterDetailRadio
            mcpId={mcpId}
            row={true}
            value={Array.isArray(value) ? null : value}
            handleChange={(val) => {
              if (val) {
                onMCPChange(fieldKey, val);
              }
            }}
            sx={{ width: '100%' }}
            cachedData={cachedData}
            cacheLoaded={cacheLoaded}
            disabled={!extraAccess}
          />
        )}
      </Grid>
    </Grid>
  );
};

